import React from "react";
import { Row, Col, Form } from "react-bootstrap";
import "./MultiSiteGroupInfo.css";

interface MultiSiteGroupInfoProps {
  formData: any;
  setFormData: React.Dispatch<React.SetStateAction<any>>;
}

const MultiSiteGroupInfo: React.FC<MultiSiteGroupInfoProps> = ({
  formData,
  setFormData,
}) => {
  const flatData = {
    isNotApplicable: formData["Multi_Site_Group_Information__c"] || false,
    description: formData["Description_Group_Multisite_Level__c"] || "",
    siteInformation: [
      {
        title: "Management system (e.g. training programs for internal auditors, internal audit schedule, etc.)",
        key: "Describe_Management_System__c",
        description: formData["Describe_Management_System__c"] || "",
      },
      {
        title: "Material sourcing (e.g. training programs for internal auditors, internal audit schedule, etc.)",
        key: "Describe_Material_sourcing__c",
        description: formData["Describe_Material_sourcing__c"] || "",
      },
      {
        title: "Management of non-conformities",
        key: "Describe_Management_of_non_conformities__c",
        description: formData["Describe_Management_of_non_conformities__c"] || "",
      },
      {
        title: "Site relationships, addition/removal process",
        key: "Site_relationships_addition_removal_p__c",
        description: formData["Site_relationships_addition_removal_p__c"] || "",
      },
    ],
  };

  const formatTitle = (title:any) => {
    const regex = /(.*)(\(.+\))/; 
    const match = title.match(regex);
  
    if (!match) return <span>{title}</span>;
  
    return (
      <div style={{ fontSize: "14px", lineHeight: "100%" }}>
        <span>{match[1]}</span><br />
        <span style={{ fontSize: "10px", fontWeight: "normal" }}>{match[2]}</span>
      </div>
    );
  };
  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData((prevData: any) => ({
      ...prevData,
      Multi_Site_Group_Information__c: e.target.checked,
    }));
  };

  const handleDescriptionChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setFormData((prevData: any) => ({
      ...prevData,
      Description_Group_Multisite_Level__c: e.target.value,
    }));
  };

  const handleRowDescriptionChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    key: string
  ) => {
    setFormData((prevData: any) => ({
      ...prevData,
      [key]: e.target.value,
    }));
  };

  return (
    <>
      <div className="multi-site-header">
        <Form.Label className="me-2" style={{ marginBottom: "4px" }}>
          Multi-Site / Group Information
        </Form.Label>
        <Form.Check
          type="checkbox"
          id="na-checkbox"
          label="N/A"
          className="na-checkbox"
          checked={flatData.isNotApplicable}
          onChange={handleCheckboxChange}
        />
      </div>

      <div className="p-3">
        <p className="multi-site-description-label">
          General description of how the chain of custody is controlled at the
          group or multisite level
        </p>

        <Form.Control
          as="textarea"
          rows={3}
          placeholder="Add a description..."
          value={flatData.description}
          onChange={handleDescriptionChange}
        />

        <div className="mt-5">
          <header className="multi-site-desc-header">Description</header>
          <Row className="p-0 m-0">
            {flatData.siteInformation.map((item, index) => (
              <React.Fragment key={item.key}>
                <Col xs={4} className="multi-site-desc-cell">
                  <div className="multi-site-desc-title">{formatTitle(item.title)}</div>
                </Col>
                <Col xs={8} className="multi-site-desc-cell">
                  <Form.Control
                    type="text"
                    value={item.description}
                    onChange={(e:any) => handleRowDescriptionChange(e, item.key)}
                  />
                </Col>
              </React.Fragment>
            ))}
          </Row>
        </div>
      </div>
    </>
  );
};

export default MultiSiteGroupInfo;
